import script from "./LzYoutube.vue?vue&type=script&lang=ts&setup=true"
export * from "./LzYoutube.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__